import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { Entry } from 'src/app/models/entry';
import { filter } from '../purchase-order/purchase-order.component';
import { InventoryService } from 'src/app/services/inventory-service';
import { EntryLine } from 'src/app/models/entry-line';

@Component({
  selector: 'app-entry',
  templateUrl: './entry.component.html',
  styleUrls: ['./entry.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class EntryComponent implements OnInit {
  filters = {
    byDates: 'dates',
    byOpen: 'open',
    entry: 'open', 
    date1: new Date,
    date2: new Date,
    invoiceLess: null,
  };
  entries:Entry[] = [];
  entriesAll:Entry[] = [];
  loading:boolean = false;

  unities:filter[] = [];
  unity:filter = null;
  users:filter[] = [];
  user:filter = null;
  deliverables:boolean = false;

  showFilters:boolean = false;

  constructor( private invServ:InventoryService ) { }

  ngOnInit() {
  }

  search() {
    this.loading = true;
    if (this.filters.entry == this.filters.byDates) {
      this.invServ.getEntriesByDates(this.filters.date1, this.filters.date2).then(order => {
        this.entries = order;
        this.entriesAll = order;
        this.loading = false;
        this.showFilters = true;
        this.createFilters();
      });
    } else if(this.filters.entry == this.filters.invoiceLess){
        this.invServ.getInvoiceLessEntries().then(entry => {
          this.entries = entry;
          this.entriesAll = entry;
          this.loading = false;
        })
    } else {
      this.invServ.getOpenEntries().then(order => {
        this.entries = order;
        this.entriesAll = order;
        this.loading = false;
        this.showFilters = true;
        this.createFilters();
      });
    }
  }

  filterData() {
    this.entries = this.entriesAll.filter(or => (this.user == null || or.user_id == this.user.id) && (this.unity == null || this.hasUnity(or.lines, this.unity.id)) && (this.deliverables == false || or.lines.find(l => l.warehouse_user_id == null)));
  }

  hasUnity(lines:EntryLine[], unity:number) {
    return lines.find(u => u.unity_id == unity) ? true : false;
  }

  createFilters() {
    this.users = [];
    this.unities = [];

    for (let i = 0; i < this.entriesAll.length; i++) {
      if (!this.users.find(u => u.name == `${this.entriesAll[i].user.name} ${this.entriesAll[i].user.last_name}`)) {
        this.users.push({
          id: this.entriesAll[i].user_id,
          name: `${this.entriesAll[i].user.name} ${this.entriesAll[i].user.last_name}`,
        });
      }
      for (let j = 0; j < this.entriesAll[i].lines.length; j++) {
        if (this.entriesAll[i].lines[j].unity_id && !this.unities.find(u => u.id == this.entriesAll[i].lines[j].unity_id)) {
          this.unities.push({
            id: this.entriesAll[i].lines[j].unity_id,
            name: this.entriesAll[i].lines[j].unity_id + "",
          });
        }
      }
    }
  }

  getTotal(lines:EntryLine[]) {
    return lines.filter(ln => ln.status != 'Cancelado')
      .map(line => ((line.quantity * line.unit_price) - ((line.quantity * line.unit_price) * (line.discount / 100))) * (line.iva*1 + 1))
      .reduce((an, ac) => an + ac, 0);
  }
}
